import type { PossibleTypesMap } from "@apollo/client"

export const addressSubjectPossibleTypes: PossibleTypesMap = {
  AddressSubject: ["Company", "Contract", "User"],
}
